export const NEW_KITCHEN_CDN_PATH =
  'https://cdn.lemanapro.ru/lmru/image/upload/q_90,f_auto,c_pad,b_auto,d_photoiscoming.png/fudzi/elbrus/images/landings/new-kitchen';

export const NEW_KITCHEN_LANDING_NAME = 'new-kitchen';
